import * as React from 'react';

// Interfaces
import { ICourse } from 'store/StateInterfaces';

// Components
import Course from 'Screens/CoursesList/Student/Components/Course';

interface IProps {
    course: ICourse;
    unRegisterCourse: (number) => void;
};

export default class CourseContainer extends React.Component<IProps, {}> {
    public componentDidMount() {
        // this.setProgress();
    }

    public render() {
        let course = this.props.course;
        let baseUrl = '/courseware/course/';
        let courseUrl =  `${baseUrl}${course.id}/`;
        let infoUrl = `${courseUrl}information/`;

        let start_msg = `Course End : ${course.end_date}`;
        if (course.coursetag === 1) {
            start_msg = `Course Start : ${course.start_date}`;
        }

        return <Course
            course={course}
            start_msg={start_msg}
            unRegister={() => this.props.unRegisterCourse(course.id)}
            infoUrl={infoUrl}
            courseUrl={courseUrl}
            />;
    }

    private setProgress() {
        let course = this.props.course;
        let div = document.getElementById(`pgbar${course.id}`);
        div.style.width = `${course.progress}%`;
    }
};
